import cx from 'clsx';

import { Item } from './item';
import styles from './styles.module.scss';
import type { Component } from './types';

export const PiPriceInfoList: Component = ({
  submodelId,
  piDealers,
  onRemarkClick,
}) => {
  const filteredDealers = piDealers.filter(
    dealer => dealer.adverts.some(advert => advert.subModelId === submodelId),
  );

  const sortedDealers = filteredDealers.sort((a, b) => {
    const aAdvert = a.adverts.find(advert => advert.subModelId === submodelId);
    const bAdvert = b.adverts.find(advert => advert.subModelId === submodelId);

    if (!aAdvert?.price) {
      return 1;
    }

    if (!bAdvert?.price) {
      return -1;
    }

    return aAdvert.price - bAdvert.price;
  });

  return (
    <div className={cx(
      styles.containerRoot,
    )}>
      {sortedDealers.map((dealer, index) => (
        <Item
          key={`pi-delaer-${dealer.name}`}
          isLast={index === sortedDealers.length - 1}
          piDealer={dealer}
          submodelId={submodelId}
          onRemarkClick={onRemarkClick} />
      ))}
    </div>
  );
};
